import React from 'react';
import { Typography, Paper, Box, Button, TextField, FormControlLabel, Checkbox } from '@mui/material';

const InterviewDetails = ({ 
  selectedInterview, 
  setSelectedInterview, 
  handleNotesChange, 
  handleReviewStatusChange,
  handlePrintInterview,
  handleShareInterview,
  handleDeleteClick
}) => {
  return (
    <Paper sx={{ mb: 2, p: 2 }} id="interview-report">
      <Button onClick={() => setSelectedInterview(null)}>Back to all interviews</Button>
      <Typography variant="h6">Interview ID: {selectedInterview.id}</Typography>
      <Typography variant="body1">User: {selectedInterview.user_id}</Typography>
      <Typography variant="body1">First Name: {selectedInterview.first_name}</Typography>
      <Typography variant="body1">Last Name: {selectedInterview.last_name}</Typography>
      <Typography variant="body1">Timestamp: {new Date(selectedInterview.timestamp).toLocaleString()}</Typography>
      <Typography variant="body1">Review Date: {selectedInterview.reviewDate ? new Date(selectedInterview.reviewDate).toLocaleString() : 'Not reviewed yet'}</Typography>
      <Typography variant="body1">Review Status: {selectedInterview.reviewStatus}</Typography>
      <TextField
        label="Notes"
        value={selectedInterview.notes || ''}
        onChange={(e) => handleNotesChange(e, selectedInterview)}
        margin="normal"
        fullWidth
        multiline
        rows={4}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={selectedInterview.reviewStatus === 'reviewed'}
            onChange={(e) => handleReviewStatusChange(e, selectedInterview)}
          />
        }
        label="Reviewed"
      />
      <Box mt={2}>
        {selectedInterview.messages ? selectedInterview.messages.map((message, index) => (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Paper sx={{ p: 1, bgcolor: message.role === 'user' ? '#e0e0e0' : '#f5f5f5' }}>
              <Typography variant="body2" color="text.primary">{message.role === 'user' ? 'User: ' : 'AI: '}{message.content}</Typography>
            </Paper>
          </Box>
        )) : null}
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={handlePrintInterview}
        disabled={!selectedInterview}
      >
        Print Report
      </Button>
      <Button variant="contained" color="secondary" onClick={() => handleShareInterview(selectedInterview)}>
        Share Report
      </Button>
      <Button variant="contained" color="error" onClick={() => handleDeleteClick(selectedInterview)}>
        Delete Report
      </Button>
    </Paper>
  );
};

export default InterviewDetails;
